/* ============================================================
   MAISON APOLLINE — Product Page JS
   ============================================================ */

(function () {
  'use strict';

  // ── Countdown ──────────────────────────────────────────────
  function startCountdownFromMs(el, endMs) {
    function tick() {
      var now = Date.now();
      var diff = endMs - now;

      if (diff <= 0) {
        el.textContent = '00:00:00';
        return;
      }

      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      el.textContent =
        pad(h) + ' : ' + pad(m) + ' : ' + pad(s);

      setTimeout(tick, 1000);
    }

    tick();
  }

  function startCountdown(el, endDateStr) {
    startCountdownFromMs(el, new Date(endDateStr).getTime());
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function initCountdowns() {
    document.querySelectorAll('[data-countdown-end]').forEach(function (wrapper) {
      var el = wrapper.querySelector('.ma-countdown__timer');
      if (!el) el = wrapper;
      startCountdown(el, wrapper.dataset.countdownEnd);
    });
  }

  // ── Countdown evergreen (se régénère à chaque nouveau visiteur) ──
  function initEvergreenCountdowns() {
    document.querySelectorAll('[data-countdown-evergreen]').forEach(function (wrapper) {
      var el = wrapper.querySelector('.ma-countdown__timer');
      if (!el) el = wrapper;

      var minHours = parseFloat(wrapper.dataset.countdownMinHours) || 2;
      var maxHours = parseFloat(wrapper.dataset.countdownMaxHours) || 12;
      var storageKey = wrapper.dataset.countdownStorageKey || 'ma_evergreen_countdown';

      var now = Date.now();
      var end = parseInt(window.localStorage.getItem(storageKey), 10);

      if (!end || isNaN(end) || end <= now) {
        var rangeMs = Math.max(maxHours - minHours, 0) * 3600000;
        end = now + (minHours * 3600000) + Math.random() * rangeMs;
        end = Math.floor(end);
        window.localStorage.setItem(storageKey, String(end));
      }

      startCountdownFromMs(el, end);
    });
  }

  // ── Intercepteur cart — ouvre le tiroir après add Fly Bundles ──
  function initCartDrawerInterceptor() {
    var originalFetch = window.fetch;
    var refreshing = false;

    window.fetch = function (resource, init) {
      var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      var promise = originalFetch.apply(this, arguments);

      // Intercepte /cart/add sauf nos propres requêtes (qui incluent "sections" dans le body)
      if (/\/cart\/add/.test(url) && !refreshing) {
        var body = (init && typeof init.body === 'string') ? init.body : '';
        if (!body.includes('"sections"')) {
          promise.then(function (response) {
            if (!response.ok) return;
            refreshing = true;
            originalFetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                updates: {},
                sections: 'cart-drawer,cart-icon-bubble',
                sections_url: window.location.pathname
              })
            })
              .then(function (r) { return r.json(); })
              .then(function (data) {
                refreshing = false;
                var cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
                  cartDrawer.classList.remove('is-empty');
                  cartDrawer.renderContents(data);
                }
              })
              .catch(function () { refreshing = false; });
          });
        }
      }

      return promise;
    };
  }

  // ── Accordions ────────────────────────────────────────────
  // <details>/<summary> gère l'ouverture nativement.
  // On ferme simplement les autres quand on en ouvre un.
  function initAccordions() {
    document.querySelectorAll('details.ma-accordion').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (details.open) {
          document.querySelectorAll('details.ma-accordion[open]').forEach(function (other) {
            if (other !== details) other.removeAttribute('open');
          });
        }
      });
    });
  }

  // ── Size Guide Modal ──────────────────────────────────────
  function initSizeGuideModal() {
    var modal = document.getElementById('ma-size-guide-modal');
    if (!modal) return;

    document.querySelectorAll('[data-open-modal="ma-size-guide-modal"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });

    modal.querySelector('.ma-modal__close').addEventListener('click', closeModal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  // ── Gallery : vignettes mobile + lightbox desktop ────────
  function initGalleryLightbox() {
    var lightbox = document.getElementById('ma-lightbox');
    var featuredImg = document.getElementById('ma-gallery-featured-img');
    var featuredWrap = document.querySelector('.ma-gallery__featured');
    var items = Array.from(document.querySelectorAll('.ma-gallery__item'));
    var currentIndex = 0;

    var lightboxImg = lightbox ? lightbox.querySelector('.ma-lightbox__img') : null;

    function showMobileImage(idx) {
      var item = items[idx];
      if (!item) return;
      var src = item.dataset.src;
      var alt = item.dataset.alt || '';
      if (featuredImg && src) {
        featuredImg.style.opacity = '0';
        setTimeout(function () {
          featuredImg.src = src;
          featuredImg.alt = alt;
          featuredImg.style.opacity = '1';
        }, 150);
      }
      items.forEach(function (i) { i.classList.remove('is-active'); });
      item.classList.add('is-active');
      currentIndex = idx;

      // Fait défiler la bande de vignettes pour garder l'active visible
      item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    items.forEach(function (item, idx) {
      item.addEventListener('click', function () {
        var isMobile = window.innerWidth <= 768;

        if (isMobile) {
          showMobileImage(idx);
        } else {
          // Desktop : ouvrir le lightbox
          if (!lightbox || !lightboxImg) return;
          var fullSrc = item.dataset.full || item.dataset.src;
          var alt = item.dataset.alt || '';
          currentIndex = idx;
          lightboxImg.src = fullSrc;
          lightboxImg.alt = alt;
          lightbox.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      });
    });

    // Swipe tactile sur l'image principale (mobile) — au doigt, sans passer par les vignettes
    if (featuredWrap && items.length > 1) {
      var touchStartX = 0;
      var touchStartY = 0;

      featuredWrap.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;
      }, { passive: true });

      featuredWrap.addEventListener('touchend', function (e) {
        var deltaX = e.changedTouches[0].clientX - touchStartX;
        var deltaY = e.changedTouches[0].clientY - touchStartY;

        // Ignore les gestes trop courts ou majoritairement verticaux (scroll de page)
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

        if (deltaX < 0) {
          showMobileImage((currentIndex + 1) % items.length);
        } else {
          showMobileImage((currentIndex - 1 + items.length) % items.length);
        }
      }, { passive: true });
    }

    // Lightbox navigation
    if (lightbox) {
      lightbox.querySelector('.ma-lightbox__close').addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });

      var prevBtn = lightbox.querySelector('.ma-lightbox__nav--prev');
      var nextBtn = lightbox.querySelector('.ma-lightbox__nav--next');

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          currentIndex = (currentIndex - 1 + items.length) % items.length;
          updateLightboxImg();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          currentIndex = (currentIndex + 1) % items.length;
          updateLightboxImg();
        });
      }

      document.addEventListener('keydown', function (e) {
        if (!lightbox.classList.contains('is-open')) return;
        if (e.key === 'ArrowLeft' && prevBtn) prevBtn.click();
        if (e.key === 'ArrowRight' && nextBtn) nextBtn.click();
        if (e.key === 'Escape') closeLightbox();
      });
    }

    function updateLightboxImg() {
      if (!lightboxImg) return;
      var item = items[currentIndex];
      if (item) {
        lightboxImg.src = item.dataset.full || item.dataset.src || '';
        lightboxImg.alt = item.dataset.alt || '';
      }
    }

    function closeLightbox() {
      if (lightbox) lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  // ── Sticky Add To Cart ───────────────────────────────────
  function initStickyCart() {
    var stickyBar = document.getElementById('ma-sticky-cart');
    var ctaBtn = document.getElementById('ma-main-cta');
    if (!stickyBar || !ctaBtn) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px 0px -60px 0px' }
    );

    observer.observe(ctaBtn);

    var stickyCartBtn = stickyBar.querySelector('.ma-sticky-cart__btn');
    if (stickyCartBtn) {
      stickyCartBtn.addEventListener('click', function () {
        // Cherche le bouton ATC de Fly Bundles, sinon repli sur le bouton natif
        var form = document.querySelector('.ma-product-form');
        var flyBtn = form && form.querySelector('button:not(#ma-main-cta):not(.ma-size-guide-link)[type="button"], button:not(#ma-main-cta):not(.ma-size-guide-link)[type="submit"]');
        if (flyBtn) {
          flyBtn.click();
        } else {
          var mainBtn = document.getElementById('ma-main-cta');
          if (mainBtn) mainBtn.click();
        }
      });
    }
  }

  // ── Size Guide Widget (curseur cm → taille) ──────────────
  function initSizeGuideWidget() {
    var widget = document.querySelector('.ma-sgw');
    if (!widget) return;

    var SIZE_CHART = [
      { size: 'XS',  min: 58,  max: 65,  fr: '34-36' },
      { size: 'S',   min: 66,  max: 72,  fr: '38-40' },
      { size: 'M',   min: 73,  max: 80,  fr: '42-44' },
      { size: 'L',   min: 81,  max: 90,  fr: '44-46' },
      { size: 'XL',  min: 91,  max: 100, fr: '48-50' },
      { size: '2XL', min: 101, max: 110, fr: '52-54' },
      { size: '3XL', min: 111, max: 120, fr: '56-58' }
    ];

    var slider    = widget.querySelector('.ma-sgw__slider');
    var cmEl      = widget.querySelector('.ma-sgw__cm');
    var resultEl  = widget.querySelector('.ma-sgw__result-size');
    var recSizeEl = widget.querySelector('.ma-sgw__rec-size');
    var recFrEl   = widget.querySelector('.ma-sgw__rec-fr');
    var sizeBtns  = widget.querySelectorAll('.ma-sgw__size-btn');

    function getSizeData(cm) {
      for (var i = 0; i < SIZE_CHART.length; i++) {
        if (cm >= SIZE_CHART[i].min && cm <= SIZE_CHART[i].max) return SIZE_CHART[i];
      }
      return SIZE_CHART[SIZE_CHART.length - 1];
    }

    function updateFromCm(cm) {
      var data = getSizeData(cm);
      cmEl.textContent      = cm;
      resultEl.textContent  = data.size;
      recSizeEl.textContent = data.size;
      recFrEl.textContent   = data.fr;
      var pct = (cm - 58) / (120 - 58) * 100;
      slider.style.setProperty('--sgw-fill', pct.toFixed(1) + '%');
      sizeBtns.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.size === data.size);
      });
    }

    slider.addEventListener('input', function () {
      updateFromCm(parseInt(this.value, 10));
    });

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var data = null;
        for (var i = 0; i < SIZE_CHART.length; i++) {
          if (SIZE_CHART[i].size === btn.dataset.size) { data = SIZE_CHART[i]; break; }
        }
        if (!data) return;
        var mid = Math.round((data.min + data.max) / 2);
        slider.value = mid;
        updateFromCm(mid);
      });
    });

    updateFromCm(parseInt(slider.value, 10));
  }

  // ── Init ─────────────────────────────────────────────────
  function init() {
    initCountdowns();
    initEvergreenCountdowns();
    initCartDrawerInterceptor();
    initAccordions();
    initSizeGuideWidget();
    initSizeGuideModal();
    initGalleryLightbox();
    initStickyCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
